export default [
    {
        path: '/joins',
        name: 'joins',
        component: () => import ('./pages/JoinRegister')
    }
]